const config = {
  stripe: {
    apiKey: '',
    apiUrl: 'https://0oq6agyxu4.execute-api.us-east-1.amazonaws.com/dev/charges',
    currency: 'USD',
  },
};

export default config;
